import { captureException } from '@sentry/react';
import { environment } from 'app/config/environment';
import axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';
const caseMiddlewareOptions = {
  ignoreHeaders: true,
  preservedKeys: input => {
    if (['_destroy', '_id'].includes(input)) return true;
    // preserve keys using UUIDs
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(input);
  }
};

// No baseURL: the region is set per navigation by route middleware, or passed per request.
export const axiosInstance = applyCaseMiddleware(axios.create(), caseMiddlewareOptions);
export const globalAxiosInstance = applyCaseMiddleware(axios.create({
  baseURL: environment.GLOBAL_API_URL
}), caseMiddlewareOptions);
export const setAxiosBaseURL = baseURL => {
  try {
    // Validate URL format
    new URL(baseURL);
    axiosInstance.defaults.baseURL = baseURL;
  } catch (error) {
    captureException(error);
  }
};
export default axiosInstance;